import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    const lang = e.target.value;
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang); // 👈 save
  };

  return (
    <select value={i18n.language} onChange={changeLanguage}>
      <option value="en">English</option>
      <option value="ml">മലയാളം</option>
      {/* <option value="hi">हिन्दी</option> */}
    </select>
  );
};

export default LanguageSelector;
